import Interceptor from "@/plugins/interceptor";
const urlAPI = `${process.env.VUE_APP_URL_API}/neighregistration`;

const attachmentSections = {
  'PROCEDURE': 'procedureattachment',
  'RESIDENT': 'procedureresidentattachment',
  'TITULAR': 'proceduretitularattachment',
  'VEHICLE': 'procedurevehicleattachment',
  'BENEFICIARY': 'procedurebeneficiaryattachment'
}

const attachsDictionary = {
  'PROCEDURE': {
    'Contrato de locación': 'LocationContract',
    'Documentación de compra': 'SaleDocument',
    'Factura de Servicio Público': 'PublicServiceBill'
  },
  'RESIDENT': {
    'Identificación frente': 'IdFront',
    'Identificación dorso': 'IdBack',
    'Cert. de reincidencia': 'IdRecurrence',
    'Precaria o Cert. de Residencia': 'IdResidence',
    'Img. de reconocimiento facial': 'IdFacialRecognition',
  },
  'TITULAR': {
    'Identificación frente': 'IdFront',
    'Identificación dorso': 'IdBack',
    'Cert. de reincidencia': 'RNR',
    'Cert. de representación': 'ProxyCertificate',
    'Precaria o Cert. de Residencia': 'IdResidence',
    'Img. de reconocimiento facial': 'IdFacialRecognition',
    'Estatuto': 'Statute', 
  },
  'VEHICLE': {
    'Cédula frente': 'IdentificationCardFront',
    'Cédula dorso': 'IdentificationCardBack',
    'Contrato de alquiler': 'RentalContract'
  }
};

const neighregistration = {
  state: {
    Enums: {},
    ListRelatedPerson: []
  },
  actions: {
    getEnums({ commit }) {
      Interceptor.get(`${urlAPI}/enumsAll`).then(res => {
        commit('SET_ENUMS', res.data)
      })
    },

    getProcedureInitDescription(_,params) {
      return new Promise((resolve, reject) => {
        Interceptor.get(`${urlAPI}/procedureinitdescription/${params.ucode}`)
          .then(res => resolve(res.data))
          .catch(res => reject(res.data));
      });
    },

    createsellprocedure() {},

    createrentprocude() {},

    getTerminosYCondiciones() {
      return new Promise((resolve, reject) => {
        Interceptor.get(`${urlAPI}/termsandconditionscontent`)
          .then(res => resolve(res.data))
          .catch(res => reject(res.data));
      });
    },

    uploadFile({ commit }, { file, section, attachmentTypeId }) {
      return new Promise((resolve, reject) => {
        if (!file) {
          reject(commit);
        }
        
        const formData = new FormData();
        formData.append('file', file);
        Interceptor.post(`${urlAPI}/${attachmentSections[section]}/upload/${attachmentTypeId}`, formData)
          .then(res => resolve(res.data));
      });
    },
    
    getRelatedPersons({commit}, params) {
      Interceptor.get(`${urlAPI}/procedure/${params.procedureCode}/relatedpersons`).then(res => {
        commit('SET_RELATED_PERSONS', res.data)
      })
    }
  },
  mutations: {
    SET_ENUMS(state, value) {
      state.Enums = value
    },
    SET_RELATED_PERSONS(state, value) {
      state.ListRelatedPerson = value
    },
    SET_PROCEDURE_INIT_DESCRIPTION(state, value) {
      state.ProcedureInitDescription = value
    }

  },
  getters: {
    attachsRent: (state) => {
      if (state.Enums.ProcedureAttachType) {
        return state.Enums.ProcedureAttachType.filter(e => e.Name != 'Documentación de compra');
      } else {
        return []
      }
    },
    attachsSell: (state) => {
      if (state.Enums.ProcedureAttachType) {
        return state.Enums.ProcedureAttachType.filter(e => e.Name !== 'Contrato de locación');
      } else {
        return []
      }
    },
    findAttachPropByName: () => (name, section) => {
      return attachsDictionary[section][name];
    }
  }
}

export default neighregistration;